<template>
    <el-form-item class="vehicule-cascader" prop="vehicule" :label="label">
        <el-cascader ref="cascaderVehicule" @active-item-change="handleItemChangeVehicule" clearable :props="{label: 'label', value: 'value'}" :options="vehiculesOptions" v-model="selectedValue" :placeholder="placeholder">

        </el-cascader>
    </el-form-item>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {
            vehiculesOptions: []
        };
    },
    props: {
        value: {
            required: true
        },
        label: {
            default: 'Véhicule'
        },
        placeholder: {
            default: 'Véhicule'
        }
    },
    computed: {
        selectedValue: {
            get() {
                if (!this.value) return [];
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    mounted() {
        axios.get('/vehicules/cascader').then(r => {
            this.vehiculesOptions = r.data.data;
        });
    },
    methods: {
        handleItemChangeVehicule(val) {
            var obj;
            var prev;
            val.forEach((v, k) => {
                if (!prev)
                    prev = obj = this.vehiculesOptions.find(e => e.value == v);
                else prev = obj = prev.children.find(e => e.value == v);
            });
            var url = '/vehicules/cascader/' + val.join('/');
            axios.get(url).then(r => {
                obj.children = r.data.data;
            });
            this.selectedValue = val;
        }
    }
};
</script>
<style lang="scss">
</style>
